module.exports = __webpack_public_path__ + "static/media/logofull.a00d824e.png";